module.exports = __webpack_public_path__ + "img/sinusoidal-beam.c8daefad.svg";